<template>
  <font-awesome-icon
    icon="question-circle"
    size="lg"
    class="icon"
    @click.stop="showQuiz()"/>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    quizset: {
      required: true,
      type: Object
    }
  },

  methods: {
    showQuiz: function () {
      this.$router.push({
        name: 'quizset-quiz',
        params: { id: this.quizset.id}
      })
    }
  }
}
</script>
